import type { MapSource } from '~/_shared/types/map';

export const checkIsSalesforceMap = (mapInfo: Readonly<{
  source: MapSource;
}> | null): boolean => {
  return mapInfo?.source === 'salesforce';
};
